import { render, staticRenderFns } from "./SelectLifetimePlan.vue?vue&type=template&id=3f4c3a9e"
import script from "./SelectLifetimePlan.vue?vue&type=script&lang=js"
export * from "./SelectLifetimePlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f4c3a9e')) {
      api.createRecord('3f4c3a9e', component.options)
    } else {
      api.reload('3f4c3a9e', component.options)
    }
    module.hot.accept("./SelectLifetimePlan.vue?vue&type=template&id=3f4c3a9e", function () {
      api.rerender('3f4c3a9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Payment/SelectLifetimePlan.vue"
export default component.exports